module.exports = "/_next/static/images/a2270553bf945747717d883c3286bac0-pregnant-woman@tablet@2x.jpg";